import BaseComponent from "../../../../baseComponent.js";

export default class AlignOptions extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      align: props.align
    }
  }

  onOptionValueClick(align) {
    this.props.onOptionValueClick(align);
    this.setState({align});
  }

  componentWillReceiveProps(nextProps) {
    this.setState({align: nextProps.align});
  }

  showOptions(ref) {
    let element = this.refs[ref];
    this.props.onOptionClick(element);
  }

  render() {
    return (
      <div>
        <div className='tw-option-container'>
          <div className='t-col single' ref="align"
               onClick={() => this.showOptions("alignOptions")} style={{textAlign: 'left', padding: '0 10px'}}>
            align: {this.state.align}
          </div>
        </div>
        <div className='option-list length' ref="alignOptions"
             style={{width: '168px', height: '105px', overflowY: 'auto'}}>
          <div className="item" onClick={() => this.onOptionValueClick('left')}>Left</div>
          <div className="item" onClick={() => this.onOptionValueClick('center')}>Center</div>
          <div className="item" onClick={() => this.onOptionValueClick('right')}>Right</div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/textual/style/alignOptions.jsx